import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { initBlock, resetBlock } from './WifiManagementBlockSlice';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';

//pages
import SubscribersPage from './Pages/SubscribersPage/SubscribersPage';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import ChooseNetworkPage from './Pages/ChooseNetworkPage/ChooseNetworkPage';
import HomeNetworkPage from './Pages/HomeNetworkPage/HomeNetworkPage';
import NetworkTypePage from './Pages/NetworkTypePage/NetworkTypePage';
import GuestNetworkInfoPage from './Pages/GuestNetworkInfoPage/GuestNetworkInfoPage';
import GuestNetworkPage from './Pages/GuestNetworkPage/GuestNetworkPage';
import AddNetworkPage from './Pages/AddNetworkPage/AddNetworkPage';

const WifiManagementBlock = (props) => {
    let currentView = null;

    useEffect(() => {
        props.initBlock({ wifiManagementBlock: props.iContent });
        return () => {
            props.resetBlock();
        }
    }, []);

    useClearStateResetFlag();

    switch (props.page) {
        case 'subscribersPage': currentView = <SubscribersPage />; break;
        case 'errorPage': currentView = <ErrorPage />; break;
        case 'chooseNetworkPage': currentView = <ChooseNetworkPage />; break;   
        case 'homeNetworkPage': currentView = <HomeNetworkPage />; break;  
        case 'networkTypePage': currentView = <NetworkTypePage />; break;
        case 'guestNetworkInfoPage': currentView = <GuestNetworkInfoPage />; break;           
        case 'guestNetworkPage': currentView = <GuestNetworkPage />; break; 
        case 'addNetworkPage': currentView = <AddNetworkPage />; break;                          
    }

    return (
        <div className='page-content'>
            {currentView}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        page: state.wifiManagementBlock.page,
    };
};

const mapDispatchToProps = { initBlock, resetBlock };

export default connect(mapStateToProps, mapDispatchToProps)(WifiManagementBlock);